import { ApiConfigs } from "../configs/ApiConfigs";
import { GuardianForm } from "../models/api-models/guardians/guardian-form";
import { GuardianFormSubmission } from "../models/api-models/guardians/guardian-form-submission";
import { HttpUtility } from "../utilities/HttpUtility";
import { Api } from "./Api";

export class GuardianApi { 
    private static get athleticFormsApiUrl(): string {
        return HttpUtility.combine(ApiConfigs.athleticFormsApiUrl, 'v1/public-forms');
    }

    static async getFormSubmission(submissionId: string, guardianId: string): Promise<GuardianFormSubmission> {
        let url = HttpUtility.combine(this.athleticFormsApiUrl, 'form-submission', submissionId, guardianId);
        return await Api.get<GuardianFormSubmission>(url);
    }

    static async getForm(submissionId: string, guardianId: string): Promise<GuardianForm> {
        let url = HttpUtility.combine(this.athleticFormsApiUrl, 'form', submissionId, guardianId);
        return await Api.get<GuardianForm>(url);
    }

    static async signForm(options: {signatureMediaId: string, submissionId: string, guardianId: string}) {
        const { submissionId, guardianId, signatureMediaId } = options;
        let url = HttpUtility.combine(this.athleticFormsApiUrl, 'sign-submission', submissionId, guardianId);
        return await Api.post<void>(url, { signatureMediaId });
    }
}